import type { Ref } from 'react';
import { forwardRef } from 'react';
import type { TableProps } from '@heroui/react';
import { Table as HeroUITable } from '@heroui/react';

import useMergeClassNames from '~/hooks/useMergeClassNames';

export const Table = forwardRef((props: TableProps, ref: Ref<HTMLTableElement> | undefined) => {
  const { classNames: customClassNames, ...rest } = props;

  const classNames = useMergeClassNames(
    {
      base: `overflow-y-auto`,
      th: 'bg-surface data-[hover=true]:text-foreground',
      td: 'border-b border-divider p-3',
      tr: 'hover:bg-surface-elevated transition-colors',
    },
    customClassNames,
  );

  return <HeroUITable ref={ref} classNames={classNames} isHeaderSticky removeWrapper {...rest} />;
});

Table.displayName = 'Table';

export { TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@heroui/react';
